import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuth, applyActionCode } from 'firebase/auth';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import styles from './BrowsePage.module.css';

export default function VerifySuccess() {
  const [status, setStatus] = useState('Verifying your email...');
  const location = useLocation();
  const navigate = useNavigate();
  const isVerifying = useRef(false);

  useEffect(() => {
    const handleVerify = async () => {
      if (isVerifying.current) return;
      isVerifying.current = true;

      const queryParams = new URLSearchParams(location.search);
      const oobCode = queryParams.get('oobCode');

      if (!oobCode) {
        setStatus('Invalid or missing verification link.');
        return;
      }

      try {
        const auth = getAuth();
        await applyActionCode(auth, oobCode);
        
        // At this point, the email is verified in Auth.
        // Also update Firestore if the user is already signed in.
        if (auth.currentUser) {
          await updateDoc(doc(db, 'users', auth.currentUser.uid), {
            isVerified: true
          });
          // Refresh user token
          await auth.currentUser.getIdToken(true);
        }

        setStatus('Email verified successfully! Redirecting...');
        setTimeout(() => {
          navigate('/browse');
        }, 3000);
      } catch (error) {
        console.error('Error verifying email:', error);
        
        // If the action code is invalid, but the user is logged in, their profile might have been verified already
        // on a previous successful strict-mode pass or session.
        if (error.code === 'auth/invalid-action-code') {
          const auth = getAuth();
          if (auth.currentUser && auth.currentUser.emailVerified) {
            setStatus('Email verified successfully! Redirecting...');
            setTimeout(() => {
              navigate('/browse');
            }, 3000);
            return;
          }
        }
        
        setStatus('Verification failed. The link might be expired or already used.');
      }
    };

    handleVerify();
  }, [location, navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '100px', minHeight: '60vh' }}>
      <div style={{ textAlign: 'center', padding: '40px', background: 'var(--card-bg)', borderRadius: '8px' }}>
        <h2>{status}</h2>
      </div>
    </div>
  );
}
